"use strict";
exports.__esModule = true;
exports.PORTAL_SELECTION = void 0;
exports.PORTAL_SELECTION = {
    HEADER: 'Which rent portal do you use?',
    BODY: 'Most properties use a website or app to collect rent. Flex integrates with these portals to pay your rent.',
    NO_PORTAL: 'My portal isn’t listed',
    SEARCH_INPUT_LABEL: 'Search portals or type URL',
    SEARCH_INPUT_PLACEHOLDER: 'Portal name...'
};
